import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface BreadcrumbItem {
  label: string;
  action?: () => void;
}

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent {
  @Input() items: BreadcrumbItem[] = [];
  @Output() itemClick = new EventEmitter<BreadcrumbItem>();

  onItemClick(item: BreadcrumbItem, index: number): void {
    if (index === this.items.length - 1) {
      return;
    }

    if (item.action) {
      item.action();
    }

    this.itemClick.emit(item);
  }

  isLastItem(index: number): boolean {
    return index === this.items.length - 1;
  }
}
